
import React from 'react';
import parties from '../data/parties.json';
import { Route, Routes } from 'react-router-dom';
import { CountryPageV2 } from "./CountryPageV2";
import { AllPageV2 } from './AllPageV2';
import { PredictionEu } from "../items/PredictionEu";
import { ResultPage } from './ResultPage';
import { EuResultPage } from './EuResultPage';
import { getAllCountries } from '../calculations/utilsV2';

export const CountriesHeaderV2 = () => {
    const allCountries = getAllCountries();//.filter(x => x.Region === null);
    const countryList = allCountries.map(x => x.Short).filter(x => x); //parties.map(x => x.short).filter(x => !["UK", "CY"].includes(x ?? ''));
    //countryList.splice(0, 0, "EU");
    countryList.splice(0, 0, "All");
    const regionList = allCountries.filter(x => x.Region !== null).map(x => x.Region); //parties.map(x => x.region).filter(x => x);

    //console.log(countryList);
    return (
        <div className="wrap">
            {/*<Router>*/}
                <Routes>
                    {countryList.map(x => <Route key={x} path={x ?? ''} element={<CountryElement short={x ?? ''} />} />)}
                    {countryList.map(x => <Route key={x+'_result'} path={x+'/result/'} element={<CountryElement short={x+'/result/'} />} />)}
                    <Route path="/" element={<CountryElement short="All" />} />
                    {regionList.map(x => <Route key={x} path={"/region/"+x} element={<CountryElement short={'/region/'+x} region={x ?? ''} />} />)}
                    <Route path="EU-result" element={<CountryElement short="EU-result" />} />
                </Routes>
            {/*</Router>*/}
        </div>
    )
}

interface CountryElementProps {
    short: string,
    region?: string,
}

const CountryElement = (props: CountryElementProps) => {
    const { short, region } = props;
    //let navigate = useNavigate();

    const convertName = (short: string) => { 
        return parties.find(x => x.short === short)?.country ?? short;
    }

    /*useEffect(() => {        
        window.addEventListener("message", ev => {
            if (parties.map(x => x.short).includes(ev.data) || ["All", "EU"].includes(ev.data)) {
                navigate("/" + ev.data);
            }
        });
    }, [short, navigate]);*/

    return (
        <div className="all">
            {short !== "EU" && short !== "All" && short !== "EU-result" && !short.includes("/result") && !short.includes("/region") &&
                <CountryPageV2 country={convertName(short)} />
            }
            {short === "EU" &&
                <PredictionEu />
            }
            {(short === "All" || short === '') &&
                <AllPageV2 />
            }
            {short.includes("/result") &&
                <ResultPage country={convertName(short.substring(0, short.indexOf('/result')))} />
            }
            {short === "EU-result" &&
                <EuResultPage />
            }
            {short.includes("/region") &&
                <CountryPageV2 region={region} />
            }
        </div>
    )
}